import { StoreColourSetting } from 'Shared/backend/settingsPage/ColourSetting';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function ScrollbarColour()
{
	return (
		<StyleFieldsRow>
			<ScrollbarColourFields />
		</StyleFieldsRow>
	);
}


/* The two scrollbar colours on their own, for a caller that names the location itself - see
   ruleProperties(). 'scrollbar-color' takes the handle colour then the track colour; an unset pair
   contributes nothing. */
export function ScrollbarColourFields()
{
	return (<>
		<StoreColourSetting field='handle' label='Handle' notes='' />
		<StoreColourSetting field='track' label='Track' notes='' />
	</>);
}
